/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useEffect, useState } from "react";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { useAuth } from "cms/auth/hooks/use-auth";
import { objectHasKeys } from "utils/empty-exists";
import { TextStyleLink } from "cms/links/link/text-link";
import { UnderlineStyleLink } from "cms/links/link/underline-link";
import { BulletPointStyleLink } from "cms/links/link/bullet-point";
import { CTAStyleLink } from "cms/links/link/cta-link";
import { LINK_FORMATS } from "cms/links/link/helpers";

const Link = (props) => {
    
    const { link, style, format } = props;
    const { token } = useAuth();
    const { link: guid } = link || {};
    const [linkData, setLinkData] = useState(null);
    
    const isTextLink = format === LINK_FORMATS.TEXT;
    const isUnderlineLink = format === LINK_FORMATS.UNDERLINE;
    const isBulletpointLink = format === LINK_FORMATS.BULLET_POINT;
    const isCtaLink = format === LINK_FORMATS.CTA;
    
    useEffect(() => {
        const load = async () => {
            if (guid) {
                const _link = await SimpliCityAdminSDK.link.findOne(token, guid);
                if (Object.keys(_link).length > 0) {
                    setLinkData(_link);
                }
            }
        };
        // load once
        if (!linkData) {
            load();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [guid]);

    return (
        <Fragment>
            {objectHasKeys(linkData) && (
                <Fragment>
                    {isTextLink &&
                        <TextStyleLink link={linkData} style={style} />
                    }
                    {isUnderlineLink &&
                        <UnderlineStyleLink link={linkData} style={style} />
                    }
                    {isBulletpointLink &&
                        <BulletPointStyleLink link={linkData} style={style} />
                    }
                    {isCtaLink &&
                        <CTAStyleLink link={linkData} style={style} />
                    }
                </Fragment>
            )}
        </Fragment>
    );
};

export default Link;
